import { AlertCallout, AlertContent, AlertTitle } from "#ui/alert";
import { Card, CardContent, CardHeader } from "#ui/card";
import { LinkButton } from "#ui/link";
import { H2 } from "#ui/typography";

export function MaintenanceCard({
  children,
  title,
}: {
  children: React.ReactNode;
  title?: string | null | undefined;
}) {
  return (
    <Card>
      <CardHeader>
        <H2 size="h6">{title ?? "Page Currently Down for Maintenance"}</H2>
      </CardHeader>
      <CardContent className="space-y-30px">
        <AlertCallout intent="warning">
          <AlertContent>
            <AlertTitle>{children}</AlertTitle>
          </AlertContent>
        </AlertCallout>
        <div>
          <LinkButton href="/">Go to dashboard</LinkButton>
        </div>
      </CardContent>
    </Card>
  );
}
